import { render, staticRenderFns } from "./ProjectSummaryBox.vue?vue&type=template&id=27216a08&"
import script from "./ProjectSummaryBox.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports